@if (open()) {
  <div
    #popoverPanel
    class="popover-panel"
    [class.top]="verticalPosition() === 'top'"
    [class.bottom]="verticalPosition() === 'bottom'"
    [class.left]="horizontalPosition() === 'left'"
    [class.right]="horizontalPosition() === 'right'"
    [style.width]="width()"
  >
    <ng-content></ng-content>
  </div>
}
